import React from 'react'
import { Button } from './ui/button'

interface HoldToConfirmButtonProps {
	className?: string
	variant?: 'default' | 'outline'
	onSubmit: () => void
	holdDelay?: number
	children: React.ReactNode
	disabled?: boolean
}

export const HoldToConfirmButton: React.FC<HoldToConfirmButtonProps> = ({
	className,
	variant,
	onSubmit,
	disabled = false,
	holdDelay = 1000,
	children,
}) => {
	const [percentage, setPercentage] = React.useState(0)
	const startTime = React.useRef<number | null>(null)
	const holdIntervalRef = React.useRef<NodeJS.Timeout | null>(null)

	React.useEffect(() => {
		return () => {
			holdIntervalRef.current && clearInterval(holdIntervalRef.current)
		}
	}, [])

	const startCounter = () => {
		if (holdIntervalRef.current) return
		startTime.current = Date.now()
		holdIntervalRef.current = setInterval(() => {
			if (startTime.current) {
				setPercentage(
					Math.floor(((Date.now() - startTime.current) / holdDelay) * 100),
				)
				if (Date.now() - startTime.current > holdDelay) {
					stopCounter()
					onSubmit()
				}
			}
		}, 10)
	}

	const stopCounter = () => {
		startTime.current = null
		setPercentage(0)
		if (holdIntervalRef.current) {
			clearInterval(holdIntervalRef.current)
			holdIntervalRef.current = null
		}
	}

	const rgb = variant === 'default' ? 'rgb(15, 23, 42)' : ''

	return (
		<Button
			className={className}
			variant={variant}
			onMouseDown={startCounter}
			onMouseUp={stopCounter}
			onMouseLeave={stopCounter}
			onTouchStart={startCounter}
			onTouchCancel={stopCounter}
			onTouchEnd={stopCounter}
			disabled={disabled}
			style={{
				background: `${rgb} linear-gradient(green, green) no-repeat top left`,
				backgroundSize: `${percentage}% 100%`,
			}}
		>
			{children}
		</Button>
	)
}
